import { createSlice } from '@reduxjs/toolkit';

const userPreRegistration = createSlice({
	name: 'preRegistration',
	initialState: {
		loading: false,
		loadingSelectedPreRegister: false,
		success: null,
		email:'',
		emailExist: false,
		userPreRegister: null,
		allPreRegisters: [],
		preRegisterSelected: []
	},
	reducers: {
		// Email verification
		emailVerificationStart: (state, action) => {
			state.loading = true;
			state.email = action.payload;
		},
		emailVerificationSuccess: (state, action) => {
			state.loading = false;
			state.emailExist = action.payload.data.emailExist;
			state.userPreRegister = action.payload.data?.userPreRegister;
		},
		emailVerificationFailure: (state) => {
			state.loading = false;
			state.email = '';
			state.emailExist = false;
		},
		// Reset email
		resetEmailVerification: (state, action ) => {
			state.emailExist = false;
			state.email = '';
			state.userPreRegister = null;
			state.success = null;
			state.loading = false;
		},
		// Pre registration data
		preRegistrationStart: (state) => {
			state.loading = true;
		},
		preRegistrationSuccess: (state, action) => {
			state.loading = false;
			const body = action.payload?.data;
			state.success = body?.success ?? true;
			if (body?.data && typeof body.data === 'object' && body.data._id) {
				state.userPreRegister = body.data;
			}
		},
		preRegistrationFailure: (state, action) => {
			state.loading = false;
			state.success = action.payload.data.success;
		},
		// Validate payment 
		validatePaymentStart: (state, action) => {
			state.loading = true;
		},
		validatePaymentSuccess: (state, action) => {
			state.loading = false;
			state.success = action.payload?.data?.success;
		},
		validatePaymentFailure: (state, action) => {
			state.loading = false;
		},
		// Get all pre register
		getAllPreRegisterStart: (state, action) => {
			state.loading = true;
		},
		getAllPreRegisterSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.allPreRegisters = data;
		},
		getAllPreRegisterFailure: (state, action) => {
			state.loading = false;
		},
		// Clean pre register selected state
		cleanSelectedPreRegister: (state, action) => {
			state.allPreRegisters = [];
			state.preRegisterSelected = [];
		},
		// User pre register selected
		getSelectedPreRegisterStart: (state) => {
			state.loadingSelectedPreRegister = true;
		},
		getSelectedPreRegisterSuccess: (state, { payload: { data } }) => {
			state.loadingSelectedPreRegister = false;
			state.preRegisterSelected = data;
		},
		getSelectedPreRegisterFailure: (state) => {
			state.loadingSelectedPreRegister = false;
		},
	},
});

export const {
	emailVerificationStart,
	emailVerificationSuccess,
	emailVerificationFailure,
	preRegistrationStart,
	preRegistrationSuccess,
	preRegistrationFailure,
	validatePaymentStart,
	validatePaymentSuccess,
	validatePaymentFailure,
	resetEmailVerification,
	getAllPreRegisterStart,
	getAllPreRegisterSuccess,
	getAllPreRegisterFailure,
	cleanSelectedPreRegister,
	getSelectedPreRegisterStart,
	getSelectedPreRegisterSuccess,
	getSelectedPreRegisterFailure
} = userPreRegistration.actions;
export default userPreRegistration.reducer;